import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {setErrorAction} from "../store/reducers/commonSlice";
import {AuthService} from "../services/AuthService";
import endpoints from "../endpoints";
import IPage from "../types/page";
import IEmail from "../types/email";

export const emailAPI = createApi({
    reducerPath: 'emailAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: `${endpoints.api}/emails`,
        prepareHeaders: (headers: Headers) => {
            const token = AuthService.getToken() || ''
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
        }
    }),
    endpoints: (builder) => ({
        getAll: builder.query<IEmail[], void>({
            query: () => {
                return {
                    url: '',
                    method: 'GET'
                }
            }
        })
    })
})